/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/commonClasses/commonContextBase.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.BusinessInfo {
    "use strict";

    interface IInheritedInfo {
        inheritedLevel: number;
        inheritedValue: string;
    }

    export class BusinessInfoContext extends Meevo.Components.CommonClasses.CommonContextBase {
        protected addSecurityKey: string;
        protected editSecurityKey: string;
        protected copySecurityKey: string;
        protected deleteSecurityKey: string;
        protected changeAccessSecurityKey: string;
        protected changeOwnerSecurityKey: string;
        private validTaxItemName = true;
        private imageGalleryService: any;
        preferencesSectionId: number = 2;
        private issingleLocation: boolean = false;
        
        constructor(
            public controller: any,
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            imageGalleryService: Meevo.Components.Common.IImageGalleryService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $mdToast: angular.material.IToastService,
            protected $translate: angular.translate.ITranslateService
        ) {
            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);
            this.todayDate = moment().startOf("day").toDate();
            // initialize end points
            this.baseEndpoint = appSettings.API_ENDPOINTS.businessInfo;
            // initialize templatepaths
            this.sectionTemplatePath = "app/plugins/businessInfo/sectionViews/";
            this.validTaxItemName = true;
            this.imageGalleryService = imageGalleryService;
            this.issingleLocation = this.isSingleLocation();
            this.initializeSections();
        }

        initializeSections(): void {
            // Adding sections items that represent areas in the maintenance form
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_BUSINESSINFO_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    "SECTION_BUSINFO_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "?includeMetadata=true",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.BusinessInfoMain,
                    this.identityService,
                    this,
                    this.modalService,
                    this.securityKeys.DATA_BUSINESSINFO_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ                    
                ));
            }            
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_BUSINESSINFO_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ImageGallerySection(3,
                    "SECTION_IMAGE_GALLERY",
                    "imageGallery.html",
                    false,
                    true,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.BusinessInfoImageGallery,
                    this.identityService,
                    this.modalService,
                    this.imageGalleryService,
                    this.securityKeys.DATA_BUSINESSINFO_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
            if (!this.isInCallCenterLocation) {
                this.sections.push(new ServiceBookingPrioritySection(4,
                    "SECTION_SERVICE_BOOKING_PRIORITY",
                    "serviceBookingPriority.html",
                    false,
                    false,
                    "",
                    "serviceBookingPriority",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.BusinessInfoServiceBookingPriority,
                    this.identityService,
                    this.modalService,
                    this.securityKeys.DATA_BUSINESSINFO_TAB_SERVICEBOOKINGPRIORITY 
                ))
            }
            if (!this.isInCallCenterLocation) {
                this.sections.push(new ServiceCategoryDisplayOrderSection(5,
                    "SECTION_SERVICE_CATEGORY_Display_Order",
                    "serviceCategoryDisplayOrder.html",
                    false,
                    false,
                    "",
                    "serviceCategoryDisplayPriority",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.BusinessInfoServiceCategoryDisplayOrder, 
                    this.identityService,
                    this.modalService,
                    this.securityKeys.DATA_BUSINESSINFO_TAB_SERVICECATEGORYDISPLAYORDER
                ))
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_BUSINESSINFO_TAB_MEEVOURL + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MeevoUrlSection(6,
                    "SECTION_MEEVO_URL",
                    "meevoUrl.html",
                    false,
                    false,
                    this.baseEndpoint,
                    "meevourl",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.BusinessInfoImageGallery,
                    this.identityService,
                    this.modalService,
                    this.busyService,
                    this.$rootScope,
                    this.$mdToast,
                    this.$translate,
                    this.securityKeys.DATA_BUSINESSINFO_TAB_MEEVOURL + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
            this.activate();
        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 3:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_BUSINESSINFO_TAB_IMAGEGALLERY);
                    break;
                case 4:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_BUSINESSINFO_TAB_SERVICEBOOKINGPRIORITY);
                    break;
                case 5:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_BUSINESSINFO_TAB_SERVICECATEGORYDISPLAYORDER);
                    break;
                case 6:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_BUSINESSINFO_TAB_MEEVOURL);
                    break;
                default:
                    this.auditNoun = Meevo.Model.NounEnum.BusinessInfo;
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_BUSINESSINFO_TAB_MAIN);
                    break;
            }
            super.selectSection(item);
        }

        protected buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            this.addSecurityKey = baseKey +
                ((hasCreateKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_CREATE : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
            this.copySecurityKey = baseKey +
                ((hasCopyKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_COPY : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);

        }

        initializeHeader(model: any): void {
            let businfoModel = <Meevo.Model.BusinessInfo>model;
            this.headerContent = businfoModel.storeName;
        }

        fileTypesEnum = Meevo.Model.FileTypes;
        bindBusinessInfoImage(url: string) {
            let fMetadata = <Model.IStorageFile>this.selectedSection.model;
            if (fMetadata) {
                url = this.searchFile(fMetadata, "Formated", url);
            }
            if (!url) {
                url = 'assets/images/photo_not_available.svg';
            }
            return url;
        }

        translateEffectiveLevel(level: number): string {
            let ret: string = "Location";
            switch (level) {
                case 0:
                    ret = "System";
                    break;
                case 1:
                    ret = "Tenant";
                    break;
                case 2:
                    ret = "BusinessType";
                    break;
            }
            return ret;
        }

        translateRule(rule: number): string {
            return rule === 2117 ? "Off Override" : "Lowest Level";
        }

        translateSettable(setLevels: number): string {
            let ret: string = "";
            if ((setLevels & 1) === 1) ret += "Tenant";
            if ((setLevels & 2) === 2) ret += " | BusinessType";
            if ((setLevels & 4) === 4) ret += " | Location";
            return ret;
        }

        getNextInheritedInfo(settingModel: Meevo.Model.SettingsDto): IInheritedInfo {

            let ret: IInheritedInfo;

            return ret;
        }

        showSettingInfo(fieldName: string, settingModel: Meevo.Model.SettingsDto) {

            let setting = _.find(settingModel.settings, setting => setting.displayName.toUpperCase() === fieldName.toUpperCase());
            if (Model.Guard.isNothing(setting)) return;
            let message: string = '';
            if ((setting.metadata.effectiveLevel & 4) == 0)
                message = 'This setting cannot be set by a location';
            else if (setting.metadata.calculationRule == Meevo.Model.OverrideRuleEnum.LowestLevel)
                if (setting.metadata.effectiveLevel == 4)
                    message = `You have overridden this setting.`; //Need more info to tell the next value up  'The inherited value is `;
                else
                    message = `You can edit this setting.  Its value of ${setting.effectiveValue} comes from the ${this.translateEffectiveLevel(setting.metadata.effectiveLevel)}`;
            else //This is the offoveride case
                if (setting.metadata.effectiveLevel)
                    message = `You have overridden this setting.`;
                else
                    message = `You can not edit this setting.  This setting was turned off at the ${this.translateEffectiveLevel(setting.metadata.effectiveLevel)}`;

            let debugMessage: string = !this.identityService.inTestOrTrainingMode() ? '' : `<br/><br>
                                        DEBUG INFO
                                        System Value=${setting.metadata.systemValue} <br\> 
                                        Tenant Value=${setting.metadata.tenantValue} <br\> 
                                        BusinessType Value=${setting.metadata.businessTypeValue} <br\> 
                                        Location Value=${setting.metadata.locationValue} <br\> 
                                        Effective Level=${this.translateEffectiveLevel(setting.metadata.effectiveLevel)}<br\>
                                        Rule=${this.translateRule(setting.metadata.calculationRule)}<br/>
                                        Setting Settable=${this.translateSettable(setting.settableLevels)}`;

            let displayMessage: string = `<div> ${message}${debugMessage}</div>`;

            this.modalService.showCustom({
                clickOutsideToClose: true,
                escapeToClose: true,
                hasBackdrop: false,
                template: displayMessage
            });

        }

        cancel() {
            if (this.selectedSection instanceof ServiceBookingPrioritySection) {
                let section = this.selectedSection as ServiceBookingPrioritySection;
                section.isAddingCategory = false;
            }
            super.cancel();
        }

        updateTextelSystemAutoReply() {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.TEXTEL_UPDATE_SYSTEM_AUTO_REPLY_TIMER);
        }
    }
}